import { Inject, Injectable } from "@angular/core";
import { GoogleApiKeyToken } from "@shared/tokens";

@Injectable()
export class GoogleSpreadsheetService {
    constructor(@Inject(GoogleApiKeyToken) private googleApiKey: string) {}

    public async obtenerHojas(spreadsheetId: string): Promise<string[]> {
        await this.cargarGapi();
        const hojasRequest = await gapi.client.sheets.spreadsheets.get({
            spreadsheetId,
            includeGridData: false,
            fields: "sheets.properties.title"
        });
        return hojasRequest.result.sheets?.map(hoja => hoja.properties?.title ?? "")
            .filter(tituloHoja => tituloHoja !== "") ?? [];
    }

    public obtenerIdDesdeLink(link: string): string {
        const partes = link.split("/");
        const indexD = partes.findIndex(parte => parte === "d");
        return partes[indexD + 1];
    }

    private async cargarGapi() {
        await new Promise(resolve => {
            gapi.load("client", resolve);
        });
        await gapi.client.init({
            apiKey: this.googleApiKey,
            discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"]
        });
    }
}
